/** Detalhes de cidades isolados por cliente, período, fonte e filtros. */
import { useEffect, useRef, useState } from 'react'
import { getMapaCity } from '../db/api.js'
import { cityFilterKeys } from '../lib/cityMatch.js'

export const cityId = (c) => `${c.uf}|${c.name}`
const pending = { data: null, loading: true, error: null }

export function useMapaCities(startDate, endDate, clientId, source, metric, filters, cities) {
  const [state, setState] = useState({ context: '', results: {} })
  const cacheRef = useRef({ context: '', requests: new Map() })
  const context = JSON.stringify([startDate, endDate, clientId, source, metric, filters || {}])
  const selection = JSON.stringify(cities.map(({ uf, name }) => ({ uf, name })))

  useEffect(() => {
    if (!startDate || !endDate) return undefined
    let alive = true
    if (cacheRef.current.context !== context) cacheRef.current = { context, requests: new Map() }
    const cache = cacheRef.current.requests
    for (const city of JSON.parse(selection)) {
      const id = cityId(city)
      if (!cache.has(id)) {
        const request = getMapaCity({ startDate, endDate, clientId, source, metric, uf: city.uf,
          cityKeys: cityFilterKeys(city.uf, city.name), filters: JSON.parse(context)[5] })
        cache.set(id, request)
        request.catch(() => { if (cache.get(id) === request) cache.delete(id) })
      }
      cache.get(id).then(
        data => ({ data, loading: false, error: null }),
        err => ({ data: null, loading: false, error: err.message || 'Erro ao carregar a cidade' }),
      ).then(result => {
        if (alive) setState(previous => ({ context, results: {
          ...(previous.context === context ? previous.results : {}), [id]: result,
        } }))
      })
    }
    return () => { alive = false }
  }, [context, selection, startDate, endDate, clientId, source, metric])

  return cities.map(c => state.context === context ? state.results[cityId(c)] || pending : pending)
}
